module.exports = __webpack_public_path__ + "img/thickness.06f90706.png";